import { Auth, TradeDetailsPage } from 'components'

export const Add = () => {
  return (
    <Auth>
      <TradeDetailsPage />
    </Auth>
  )
}
